import { Suspense, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { WorkspaceDeskRouteGuard } from '@/app/navigation/workspace-desk-route-guard'
import { WorkspaceDeskSessionGuard } from '@/app/navigation/workspace-desk-session-guard'
import { useMeSessionQuery } from '@/features/auth/hooks/use-me-session-query'
import { resolveWorkspaceAccessToken } from '@/features/auth/session/workspace-session'
import { NotificationSession } from '@/features/notifications/components/notification-session'
import { CandidatesExportProgressBar } from '@/features/recruitment/components/candidates-export-progress-bar'
import { ProWorkingAsBanner } from './pro-working-as-banner'
import { Sidebar } from './sidebar'
import { TopBar } from './top-bar'

function RouteLoadingFallback() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center text-sm text-text-secondary">
      Loading…
    </div>
  )
}

export function AppShell() {
  const [navOpen, setNavOpen] = useState(false)
  const { pathname } = useLocation()
  const session = useMeSessionQuery()
  const tenantId = session.data?.tenantId?.trim() ?? ''

  useEffect(() => {
    setNavOpen(false)
  }, [pathname])

  return (
    <WorkspaceDeskSessionGuard>
      <div className="flex min-h-dvh bg-surface-workspace">
        {navOpen ? (
          <button
            type="button"
            className="fixed inset-0 z-30 bg-black/50 md:hidden"
            aria-label="Close menu"
            onClick={() => setNavOpen(false)}
          />
        ) : null}
        <div
          className={`fixed inset-y-0 left-0 z-40 w-[min(100%,18rem)] shrink-0 transition-transform duration-200 md:static md:z-auto md:w-[272px] md:translate-x-0 ${
            navOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
          onClick={(event) => {
            const target = event.target as HTMLElement
            if (target.closest('a')) setNavOpen(false)
          }}
        >
          <Sidebar />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <NotificationSession tenantId={tenantId} getAccessToken={resolveWorkspaceAccessToken} />
          <TopBar tenantId={tenantId} onOpenMenu={() => setNavOpen(true)} />
          <main className="flex-1 overflow-auto p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:p-4 md:p-6">
            <div className="mx-auto max-w-[1600px]">
              <ProWorkingAsBanner />
              <Suspense fallback={<RouteLoadingFallback />}>
                <WorkspaceDeskRouteGuard />
              </Suspense>
            </div>
          </main>
        </div>
        <CandidatesExportProgressBar />
      </div>
    </WorkspaceDeskSessionGuard>
  )
}
